import React from "react";

const SellerProductsContext = React.createContext();

export default SellerProductsContext;